import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../overlay/Dialog';
import OverlayController from '../overlay/OverlayController';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import PluginsManager from './PluginsManager';
import mutations from '../../graphql/mutations';
import { compose } from 'react-apollo';
import './PluginDialog.css'


export default compose(
    mutations.createPluginMutationHoc,
    mutations.updatePluginMutationHoc
)(class PluginDialog extends React.Component {

    static propTypes = {
        project: PropTypes.object.isRequired,
        plugin: PropTypes.object
    };

    static defaultProps = {
        plugin: {
            id: null,
            configuration: null,
            typeId: null,
            title: '',
            useForAllStates: true,
            stateIds: null
        }
    };

    constructor(props) {
        super(props);

        this.plugins = PluginsManager.getAvailablePlugins();
        this.editMode = this.props.plugin.id !== null;
        this.pluginComponent = null;
        this.state = {
            pluginTypeId: this.props.plugin.typeId,
            pluginTitle: this.props.plugin.title,
            useForAllStates: this.props.plugin.useForAllStates,
            stateIds: this.props.plugin.stateIds,
            configuration: this.props.plugin.configuration,
            enableSave: false
        };
    }

    didClickAdd() {
        OverlayController.showActivityIndicator();
        this.props.createPlugin(this.pluginDataFromState()).then(() => {
            OverlayController.hideActivityIndicator();
            OverlayController.hideOverlay();
        }).catch((error) => {
            OverlayController.hideActivityIndicator();
            OverlayController.showErrorAlert(error);
        });
    }

    didClickSave() {
        OverlayController.showActivityIndicator();
        this.props.updatePlugin(this.props.plugin.id, this.pluginDataFromState()).then(() => {
            OverlayController.hideActivityIndicator();
            OverlayController.hideOverlay();
        }).catch((error) => {
            OverlayController.hideActivityIndicator();
            OverlayController.showErrorAlert(error);
        });
    }

    pluginDataFromState() {
        return {
            projectId: this.props.project.id,
            typeId: this.state.pluginTypeId,
            title: this.state.pluginTitle,
            useForAllStates: this.state.useForAllStates,
            stateIds: this.state.useForAllStates ? null : (this.state.stateIds || []),
            configuration: this.pluginComponent.getConfiguration()
        };
    }

    onChangePluginTitle(pluginTitle) {
        this.setState({pluginTitle});
    }

    didChangePluginTypeId(pluginTypeId) {
        // If the selected plugin has PluginConfiguration component, disable the save button such that the component
        // will enable it when appropriate, otherwise enable it.
        if (this.state.pluginTypeId === pluginTypeId) {
            return;
        }
        let plugin = PluginsManager.getPluginByTypeId(pluginTypeId);
        if (plugin.PluginConfiguration) {
            this.disableSave();
        } else {
            this.enableSave();
        }
        this.setState({pluginTypeId});
    }

    onUserForAllStatesChanged(useForAllStates) {
        this.setState({useForAllStates})
    };

    didChangeStateIds(stateIds) {
        this.setState({stateIds});
    }

    enableSave() {
        this.setState({enableSave: true});
    }

    disableSave() {
        this.setState({enableSave: false});
    }

    isSubmitDisabled() {
        return !(this.state.enableSave && this.state.pluginTitle.length > 0 && this.state.pluginTypeId);
    }

    pluginMenuItems() {
        return this.plugins.map(plugin => {
            return <MenuItem key={plugin.pluginTypeId} value={plugin.pluginTypeId} primaryText={plugin.pluginTypeName}/>
        });
    }

    stateMenuItems() {
        return this.props.project.states
            .filter(state => state.type === 'normal' || state.type === 'null')
            .map(state => {
                return <MenuItem key={state.id} value={state.id} primaryText={state.name}/>
            });
    }

    render() {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: this.editMode ? 'Save' : 'Add', type: "submit", handler: this.editMode ? this.didClickSave.bind(this) : this.didClickAdd.bind(this), disabled: this.isSubmitDisabled()}
        ];
        let pluginConfiguration = null;
        if (this.state.pluginTypeId) {
            let PluginConfiguration = PluginsManager.getPluginByTypeId(this.state.pluginTypeId).PluginConfiguration;
            if (PluginConfiguration) {
                pluginConfiguration = <PluginConfiguration
                    ref={(pluginComponent) => { this.pluginComponent = pluginComponent; } }
                    configuration={this.state.configuration}
                    enableSave={this.enableSave.bind(this)}
                    disableSave={this.disableSave.bind(this)}
                />
            }
        }
        let stateSelectField = null;
        if (!this.state.useForAllStates) {
            stateSelectField = (
                <SelectField
                    className="custom-field custom-select-field"
                    fullWidth={true}
                    floatingLabelText="States"
                    floatingLabelFixed={true}
                    hintText="Select state"
                    value={this.state.stateIds}
                    multiple={true}
                    onChange={(event, index, value) => this.didChangeStateIds(value)}
                >
                    {this.stateMenuItems()}
                </SelectField>
            );
        }
        return (
            <Dialog showTitleBar={true} title={this.editMode ? 'Edit Plugin' : 'Add Plugin'} actions={actions} className="pluginDialog">
                <TextField
                    className="custom-field"
                    fullWidth={true}
                    floatingLabelText="Plugin Title"
                    floatingLabelFixed={true}
                    hintText="Enter title for this plugin"
                    value={this.state.pluginTitle}
                    onChange={event => this.onChangePluginTitle(event.target.value)}
                />
                <SelectField
                    disabled={this.editMode}
                    className="custom-field custom-select-field"
                    fullWidth={true}
                    floatingLabelText="Plugin Type"
                    floatingLabelFixed={true}
                    hintText="Select Plugin Type"
                    value={this.state.pluginTypeId}
                    onChange={(event, index, value) => this.didChangePluginTypeId(value)}
                >
                    {this.pluginMenuItems()}
                </SelectField>
                <Checkbox
                    className="custom-checkbox"
                    label="Use for all states"
                    checked={this.state.useForAllStates}
                    onCheck={(event, isInputChecked) => this.onUserForAllStatesChanged(isInputChecked)}
                />
                {stateSelectField}
                {pluginConfiguration}
            </Dialog>
        );
    }

});



// WEBPACK FOOTER //
// ./src/components/plugins/PluginDialog.js